/**
 * 过滤对象中的空值（null 和 undefined）
 * @param obj 要过滤的对象
 * @returns 过滤后的新对象
 */
export function filterEmptyValues(
  obj: Record<string, any>,
): Record<string, any> {
  return Object.entries(obj).reduce(
    (acc, [key, value]) => {
      // 如果值是对象且不是数组，递归处理
      if (value && typeof value === 'object' && !Array.isArray(value)) {
        const filtered = filterEmptyValues(value)
        // 只有当过滤后的对象有属性时才添加
        if (Object.keys(filtered).length > 0) {
          acc[key] = filtered
        }
        return acc
      }

      // 如果值不为 null 或 undefined，则保留
      // && !Number.isNaN(value) 暂时不过滤NaN
      if (value !== null && value !== undefined && !Number.isNaN(value)) {
        acc[key] = value
      }
      return acc
    },
    {} as Record<string, any>,
  )
}
